
















import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, State} from 'vuex-class'
import { Tag } from '@/modules/blog/types'
import {Prop} from 'vue-property-decorator';

/**
 * Selector de etiquetas del blog con auto-completado
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class TagAutocomplete extends Vue {
    /**
     * Lista de etiquetas registradas en la aplicación
     *
     * @var { Tag[] }
     */
    @State(state => state.blog.tags)
    public tags: Tag[]

    @State(state => state.blog.tagsFetched)
    public tagsFetched: boolean

    @Action('blog/loadTags')
    public loadTags: () => Promise<void>

    public loading = true

    @Prop({type: Array, default: () => []})
    public value: string[]

    /**
     * Cuando el componente es mostrado en la interfaz este carga la lista
     * de etiquetas
     */
    public async mounted () {
        await this.loadTags()
        this.loading = false
    }
}
